export const resources = {
  en: {
    'app.title': 'PhaserGame',
    'shell.label': 'PhaserGame control playground',
    'game.canvasLabel': 'Game canvas',
    'hud.label': 'Game status HUD',
    'hud.timer': 'Timer',
    'hud.health': 'Health',
    'hud.objective': 'Objective',
    'hud.wave': 'Wave',
    'hud.combo': 'Combo',
    'hud.dash': 'Dash',
    'hud.score': 'Score',
    'hud.rank': 'Rank',
    'hud.result': 'Result',
    'hud.runState': 'Run state',
    'hud.ready': 'READY',
    'hud.urgent': 'URGENT',
    'hud.expired': 'EXPIRED',
    'hud.stable': 'STABLE',
    'hud.damaged': 'DAMAGED',
    'hud.critical': 'CRITICAL',
    'hud.depleted': 'DEPLETED',
    'hud.cells': 'CELLS {current}/{total}',
    'hud.complete': 'COMPLETE',
    'hud.remaining': '{count} REMAINING',
    'hud.none': 'NONE',
    'hud.bronze': 'BRONZE',
    'hud.silver': 'SILVER',
    'hud.gold': 'GOLD',
    'hud.inProgress': 'IN PROGRESS',
    'hud.missionComplete': 'MISSION COMPLETE',
    'hud.runEnded': 'RUN ENDED',
    'hud.running': 'RUNNING',
    'hud.paused': 'PAUSED — {reasons}',
    'hud.waveValue': 'WAVE {current}/{total}',
    'hud.dashReady': 'READY',
    'pause.reason.user': 'USER',
    'pause.reason.focusLoss': 'FOCUS LOSS',
    'pause.reason.visibilityHidden': 'WINDOW HIDDEN',
    'input.source.keyboard': 'keyboard',
    'input.source.controller': 'controller',
    'input.source.touch': 'touch',
    'settings.summary': 'Local settings',
    'settings.language': 'Language',
    'settings.languageEnglish': 'English',
    'settings.languageRussian': 'Русский',
    'settings.accessibilityGroup': 'Accessibility',
    'settings.highContrast': 'High contrast',
    'settings.reducedMotion': 'Reduced motion',
    'settings.largeText': 'Large text',
    'settings.captions': 'Captions',
    'settings.audioGroup': 'Audio',
    'settings.muted': 'Mute all audio',
    'settings.masterVolume': 'Master volume',
    'settings.musicVolume': 'Music volume',
    'settings.effectsVolume': 'Effects volume',
    'settings.controlsGroup': 'Keyboard controls',
    'settings.movementKeys': 'Movement keys',
    'settings.schemeWasd': 'WASD and arrow keys',
    'settings.schemeIjkl': 'IJKL and arrow keys',
    'settings.reset': 'Reset progress…',
    'settings.saved': 'Settings saved on this device.',
    'status.unlocked': 'Unlocked: {levels}',
    'status.storageAvailable': 'Progress and settings stay on this device.',
    'status.storageUnavailable': 'Local storage unavailable. Playing safely with session-only progress.',
    'reset.title': 'Reset local progress?',
    'reset.body': 'This relocks later levels. Language and accessibility settings are preserved.',
    'reset.cancel': 'Cancel',
    'reset.confirm': 'Reset progress',
    'touch.label': 'Touch game controls',
    'touch.movement': 'Movement controls',
    'touch.actions': 'Game actions',
    'touch.moveUp': 'Move up',
    'touch.moveLeft': 'Move left',
    'touch.moveDown': 'Move down',
    'touch.moveRight': 'Move right',
    'touch.confirm': 'OK',
    'touch.attack': 'Attack',
    'touch.dash': 'Dash',
    'touch.pause': 'Pause',
    'touch.mute': 'Mute audio',
    'touch.volumeDown': 'Decrease volume',
    'touch.volumeUp': 'Increase volume',
    'status.loading': 'Game loading',
    'status.ready': 'Game ready',
    'status.paused': 'Game paused: {reasons}',
    'status.resumed': 'Game resumed',
    'status.levelStarted': 'Level 1 started',
    'caption.region': 'Sound captions',
    'caption.objective': 'Power cell collected. {count} of {total}.',
    'caption.exitOpen': 'Exit unlocked.',
    'caption.attackHit': 'Attack hit. Enemy defeated.',
    'caption.playerDamage': 'Player damaged. Combo broken.',
    'caption.pickup': 'Score pickup collected.',
    'caption.comboBreak': 'Combo reset to one.',
    'caption.wave': 'Wave {wave} started.',
    'caption.dash': 'Dash activated. Brief invulnerability.',
    'caption.muted': 'Audio muted.',
    'caption.unmuted': 'Audio unmuted.',
    'caption.volume': 'Master volume {value} percent.',
    'menu.title': 'PILOT CONTROL LAB',
    'menu.instructions': 'Move: {movement} / controller / touch\nAttack: Z / A · Dash: X / B · Pause: Escape / Menu\nPress Enter, Space, controller Y, or OK to start',
    'tutorial.title': 'ARENA CHECK · FIRST 30 SECONDS',
    'tutorial.instructions': '1  Move with {movement}\n2  Face the chaser and attack\n3  Collect its pickup, then dash away\nEscape pauses at any time',
    'tutorial.movePrompt': 'MOVE ONCE TO ARM THE LAUNCH',
    'tutorial.readyPrompt': 'READY · PRESS ENTER OR SPACE',
    'tutorial.attackPrompt': 'FACE THE CHASER · ATTACK WITH Z / A',
    'tutorial.pickupPrompt': 'MOVE TO THE PICKUP',
    'tutorial.dashPrompt': 'DASH WITH X / B',
    'tutorial.completePrompt': 'TRAINING COMPLETE · SURVIVE FIVE WAVES',
    'level.title': 'LEVEL 1 · NEON ARENA',
    'level.hazard': '⚠ HAZARD',
    'level.chaser': 'CHASER',
    'level.ranged': 'RANGED',
    'level.elite': 'FINAL ELITE',
    'level.pickup': '+ SCORE',
    'level.telegraph': '⚠ TELEGRAPH',
    'level.feedback': 'Move · Attack · Pickup · Dash',
    'level.cell': 'CELL',
    'level.exit': 'EXIT',
    'level.paused': 'PAUSED\n{reasons}',
    'level.status': 'Cells {cells}/{total}   Health {health}/{maximum}   Time {seconds}s   Exit {exit}\nScore {score}   Rank {rank}   Input {input}   Audio {audio}',
    'level.exitOpen': 'OPEN',
    'level.exitLocked': 'LOCKED',
    'level.inputIdle': 'idle',
    'level.audioMuted': 'muted',
    'level.audioVolume': '{value}%',
    'results.winTitle': 'MISSION COMPLETE',
    'results.lossTitle': 'RUN ENDED',
    'results.winDetail': 'Five waves cleared · {seconds}s\nScore {score}',
    'results.lossDetail': 'Cause: {cause}\nScore {score}',
    'results.timerExpired': 'TIME EXPIRED',
    'results.healthDepleted': 'HEALTH DEPLETED',
    'results.restart': 'PRESS ENTER OR SPACE TO RESTART LEVEL 1',
    'results.retry': 'RETRY ARENA',
    'announcement.win': 'Arena cleared. Score {score}.',
    'announcement.loss': 'Run ended: {cause}. Score {score}.',
    'announcement.timerExpired': 'time expired',
    'announcement.healthDepleted': 'health depleted',
  },
  ru: {
    'app.title': 'PhaserGame',
    'shell.label': 'Игровая зона управления PhaserGame',
    'game.canvasLabel': 'Игровое поле',
    'hud.label': 'Панель состояния игры',
    'hud.timer': 'Время',
    'hud.health': 'Прочность',
    'hud.objective': 'Цель',
    'hud.wave': 'Волна',
    'hud.combo': 'Комбо',
    'hud.dash': 'Рывок',
    'hud.score': 'Счёт',
    'hud.rank': 'Ранг',
    'hud.result': 'Результат',
    'hud.runState': 'Состояние',
    'hud.ready': 'ГОТОВО',
    'hud.urgent': 'СРОЧНО',
    'hud.expired': 'ВРЕМЯ ВЫШЛО',
    'hud.stable': 'НОРМА',
    'hud.damaged': 'ПОВРЕЖДЕНИЕ',
    'hud.critical': 'КРИТИЧНО',
    'hud.depleted': 'РАЗРУШЕНО',
    'hud.cells': 'ЯЧЕЙКИ {current}/{total}',
    'hud.complete': 'ВЫПОЛНЕНО',
    'hud.remaining': 'ОСТАЛОСЬ: {count}',
    'hud.none': 'НЕТ',
    'hud.bronze': 'БРОНЗА',
    'hud.silver': 'СЕРЕБРО',
    'hud.gold': 'ЗОЛОТО',
    'hud.inProgress': 'В ПРОЦЕССЕ',
    'hud.missionComplete': 'МИССИЯ ВЫПОЛНЕНА',
    'hud.runEnded': 'ЗАБЕГ ЗАВЕРШЁН',
    'hud.running': 'В ИГРЕ',
    'hud.paused': 'ПАУЗА — {reasons}',
    'hud.waveValue': 'ВОЛНА {current}/{total}',
    'hud.dashReady': 'ГОТОВ',
    'pause.reason.user': 'ИГРОК',
    'pause.reason.focusLoss': 'ПОТЕРЯ ФОКУСА',
    'pause.reason.visibilityHidden': 'ОКНО СКРЫТО',
    'input.source.keyboard': 'клавиатура',
    'input.source.controller': 'контроллер',
    'input.source.touch': 'сенсорный экран',
    'settings.summary': 'Локальные настройки',
    'settings.language': 'Язык',
    'settings.languageEnglish': 'English',
    'settings.languageRussian': 'Русский',
    'settings.accessibilityGroup': 'Доступность',
    'settings.highContrast': 'Высокий контраст',
    'settings.reducedMotion': 'Меньше движения',
    'settings.largeText': 'Крупный текст',
    'settings.captions': 'Субтитры',
    'settings.audioGroup': 'Звук',
    'settings.muted': 'Отключить весь звук',
    'settings.masterVolume': 'Общая громкость',
    'settings.musicVolume': 'Громкость музыки',
    'settings.effectsVolume': 'Громкость эффектов',
    'settings.controlsGroup': 'Управление с клавиатуры',
    'settings.movementKeys': 'Клавиши движения',
    'settings.schemeWasd': 'WASD и стрелки',
    'settings.schemeIjkl': 'IJKL и стрелки',
    'settings.reset': 'Сбросить прогресс…',
    'settings.saved': 'Настройки сохранены на этом устройстве.',
    'status.unlocked': 'Открыто: {levels}',
    'status.storageAvailable': 'Прогресс и настройки хранятся на этом устройстве.',
    'status.storageUnavailable': 'Локальное хранилище недоступно. Прогресс сохраняется только на время сеанса.',
    'reset.title': 'Сбросить локальный прогресс?',
    'reset.body': 'Поздние уровни снова закроются. Язык и настройки доступности сохранятся.',
    'reset.cancel': 'Отмена',
    'reset.confirm': 'Сбросить прогресс',
    'touch.label': 'Сенсорное управление игрой',
    'touch.movement': 'Управление движением',
    'touch.actions': 'Игровые действия',
    'touch.moveUp': 'Двигаться вверх',
    'touch.moveLeft': 'Двигаться влево',
    'touch.moveDown': 'Двигаться вниз',
    'touch.moveRight': 'Двигаться вправо',
    'touch.confirm': 'OK',
    'touch.attack': 'Атака',
    'touch.dash': 'Рывок',
    'touch.pause': 'Пауза',
    'touch.mute': 'Отключить звук',
    'touch.volumeDown': 'Уменьшить громкость',
    'touch.volumeUp': 'Увеличить громкость',
    'status.loading': 'Игра загружается',
    'status.ready': 'Игра готова',
    'status.paused': 'Игра приостановлена: {reasons}',
    'status.resumed': 'Игра продолжена',
    'status.levelStarted': 'Уровень 1 начат',
    'caption.region': 'Субтитры звуков',
    'caption.objective': 'Энергоячейка собрана. {count} из {total}.',
    'caption.exitOpen': 'Выход открыт.',
    'caption.attackHit': 'Попадание. Враг уничтожен.',
    'caption.playerDamage': 'Игрок повреждён. Комбо прервано.',
    'caption.pickup': 'Бонус очков собран.',
    'caption.comboBreak': 'Комбо сброшено до одного.',
    'caption.wave': 'Началась волна {wave}.',
    'caption.dash': 'Рывок активирован. Краткая неуязвимость.',
    'caption.muted': 'Звук отключён.',
    'caption.unmuted': 'Звук включён.',
    'caption.volume': 'Общая громкость: {value} процентов.',
    'menu.title': 'ЛАБОРАТОРИЯ ПИЛОТА',
    'menu.instructions': 'Движение: {movement} / контроллер / сенсорный экран\nАтака: Z / A · Рывок: X / B · Пауза: Escape / Menu\nНажмите Enter, пробел, Y на контроллере или OK',
    'tutorial.title': 'ПРОВЕРКА АРЕНЫ · ПЕРВЫЕ 30 СЕКУНД',
    'tutorial.instructions': '1  Двигайтесь с помощью {movement}\n2  Повернитесь к преследователю и атакуйте\n3  Соберите бонус и сделайте рывок\nEscape включает паузу',
    'tutorial.movePrompt': 'СДЕЛАЙТЕ ШАГ ДЛЯ ПОДГОТОВКИ',
    'tutorial.readyPrompt': 'ГОТОВО · НАЖМИТЕ ENTER ИЛИ ПРОБЕЛ',
    'tutorial.attackPrompt': 'К ВРАГУ · АТАКА Z / A',
    'tutorial.pickupPrompt': 'ДВИГАЙТЕСЬ К БОНУСУ',
    'tutorial.dashPrompt': 'РЫВОК X / B',
    'tutorial.completePrompt': 'ОБУЧЕНИЕ ЗАВЕРШЕНО · ПЕРЕЖИВИТЕ ПЯТЬ ВОЛН',
    'level.title': 'УРОВЕНЬ 1 · НЕОНОВАЯ АРЕНА',
    'level.hazard': '⚠ ОПАСНОСТЬ',
    'level.chaser': 'ПРЕСЛЕДОВАТЕЛЬ',
    'level.ranged': 'СТРЕЛОК',
    'level.elite': 'ФИНАЛЬНЫЙ ЭЛИТНЫЙ ВРАГ',
    'level.pickup': '+ ОЧКИ',
    'level.telegraph': '⚠ ПРЕДУПРЕЖДЕНИЕ',
    'level.feedback': 'Движение · Атака · Бонус · Рывок',
    'level.cell': 'ЯЧЕЙКА',
    'level.exit': 'ВЫХОД',
    'level.paused': 'ПАУЗА\n{reasons}',
    'level.status': 'Ячейки {cells}/{total}   Прочность {health}/{maximum}   Время {seconds}с   Выход {exit}\nСчёт {score}   Ранг {rank}   Ввод {input}   Звук {audio}',
    'level.exitOpen': 'ОТКРЫТ',
    'level.exitLocked': 'ЗАКРЫТ',
    'level.inputIdle': 'нет',
    'level.audioMuted': 'отключён',
    'level.audioVolume': '{value}%',
    'results.winTitle': 'МИССИЯ ВЫПОЛНЕНА',
    'results.lossTitle': 'ЗАБЕГ ЗАВЕРШЁН',
    'results.winDetail': 'Пять волн пройдено · {seconds}с\nСчёт {score}',
    'results.lossDetail': 'Причина: {cause}\nСчёт {score}',
    'results.timerExpired': 'ВРЕМЯ ВЫШЛО',
    'results.healthDepleted': 'ПРОЧНОСТЬ ИСЧЕРПАНА',
    'results.restart': 'НАЖМИТЕ ENTER ИЛИ ПРОБЕЛ ДЛЯ ПЕРЕЗАПУСКА',
    'results.retry': 'ПОВТОРИТЬ АРЕНУ',
    'announcement.win': 'Арена пройдена. Счёт {score}.',
    'announcement.loss': 'Забег завершён: {cause}. Счёт {score}.',
    'announcement.timerExpired': 'время вышло',
    'announcement.healthDepleted': 'прочность исчерпана',
  },
} as const;

export type Locale = keyof typeof resources;
export type ResourceKey = keyof (typeof resources)['en'];
export const RESOURCE_KEYS = Object.freeze(Object.keys(resources.en) as ResourceKey[]);

export const translate = (
  locale: Locale,
  key: ResourceKey,
  values: Readonly<Record<string, string | number>> = {},
): string =>
  resources[locale][key].replace(/\{([a-zA-Z]+)\}/gu, (_placeholder, name: string) => {
    const value = values[name];
    if (value === undefined) throw new Error(`Missing translation value: ${name}`);
    return String(value);
  });
